export default __webpack_public_path__ + "static/media/medicos_validación_fallida.1e46c069.svg";